import type { DraggableProvided } from '@hello-pangea/dnd';

import { Card, DisabledOverlay, Flex, Highlight, Stack, Text } from '@highlight-cp/core-ui';

import { ActionIcons } from '../action-icons';

interface DragToAddCardProps {
  addTooltip?: string;
  description?: string;
  disabled?: boolean;
  dragHandleTooltip?: string;
  onAddClick?: () => void | Promise<void>;
  provided: DraggableProvided;
  title: string;
  searchText?: string;
}

const DragToAddCard = ({
  addTooltip,
  description,
  disabled,
  dragHandleTooltip,
  onAddClick,
  provided,
  title,
  searchText,
}: DragToAddCardProps) => {
  return (
    <Card
      px="sm"
      py="xs"
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
    >
      <Stack gap="xs">
        <Flex align="center" justify="space-between">
          <Flex align="center" gap="xs">
            <ActionIcons.Drag
              disabled={disabled}
              ariaLabel={dragHandleTooltip}
              tooltip={dragHandleTooltip}
            />
            <Highlight fw={600} highlight={searchText ?? ''}>
              {title}
            </Highlight>
          </Flex>
          {onAddClick && (
            <ActionIcons.Add
              disabled={disabled}
              ariaLabel={addTooltip}
              tooltip={addTooltip}
              onClick={onAddClick}
            />
          )}
        </Flex>
        {description && (
          <Text size="sm" c="dimmed">
            {description}
          </Text>
        )}
      </Stack>
      {disabled && <DisabledOverlay />}
    </Card>
  );
};

export default DragToAddCard;
